import { c as constructFrom } from './toDate.js';

function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(
    null,
    context || dates.find((date) => typeof date === "object"),
  );
  return dates.map(normalize);
}

export { normalizeDates as n };

//# sourceMappingURL=normalizeDates.js.map